query getSmartRecruitersPostings(
  $language: String!
  $query: String
  $destination: SmartRecruitersDestinationQuery
  $locationType: SmartRecruitersLocationTypeQuery
  $country: String
  $region: String
  $city: String
  $department: String
) {
  getSmartRecruitersPostings(
    language: $language
    query: $query
    destination: $destination
    locationType: $locationType
    country: $country
    region: $region
    city: $city
    department: $department
  ) {
    totalFound
    content {
      id
      uuid
      name
      refNumber
      company {
        identifier
        name
      }
      releasedDate
      location {
        country
        region
        city
        remote
      }
      industry {
        id
        label
      }
      department {
        id
        label
        description
      }
      function {
        id
        label
      }
      typeOfEmployment {
        id
        label
      }
      experienceLevel {
        id
        label
      }
      customField {
        fieldId
        fieldLabel
        valueId
        valueLabel
      }
      ref
      creator {
        name
      }
      language {
        code
        label
        labelNative
      }
    }
  }
}
